import React from "react";

export default function OneContact({ name, content, icon }) {
  return (
    <div className="group flex flex-col items-center text-center p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100">
      <div className="mb-4">{icon}</div>
      <h3 className="text-lg font-bold text-gray-900 mb-2">{name}</h3>
      {content.map((el, index) => (
        <p key={index} className="text-gray-600">
          {el}
        </p>
      ))}
    </div>
  );
}
